import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { actions } from '@/redux/tour/reducer';
import EmptyList from '@/components/EmptyList';
import Filters from '@/components/TourFilters';
import { EmptyListIcon } from '@/assets/images/icons/screens';
import { dateFormat } from '@/helpers/dateFormat';

import CruiseList from './CruiseList';
import Loading from './Loading';

const ViewAll = () => {
    const dispatch = useDispatch();

    const maxPrice = useSelector((state) => state.maxprice.tourMaxPrice);

    const [filters, baseSetFilters] = useState({ prices: [0, 0] });
    useEffect(() => {
        if (maxPrice !== null) {
            baseSetFilters({ prices: [0, maxPrice] });
        }
    }, [maxPrice]);

    const [viewMode, setViewMode] = useState('list');
    const [page, setPage] = useState(1);

    const handleFetchTourCruises = useCallback(
        ({ perPage = 10, currentPage = 1, fetchMore }) => {
            const data = {
                name: filters.name,
                location: filters.location,
                start_date: filters.date?.[0].format(dateFormat),
                end_date: filters.date?.[1].format(dateFormat),
                min_price: filters.prices[0],
                max_price: filters.prices[1],
                // eslint-disable-next-line object-shorthand
                perPage: perPage,
                page: currentPage,
            };
            filters.prices[1] !== 0 && dispatch(actions.requestFetchTourCruises(data, fetchMore));
            setPage(currentPage + 1);
        },
        [
            dispatch,
            filters.location,
            filters.name,
            filters.prices,
            filters.date,
        ],
    );

    const setFilters = useCallback((name, value) => {
        const variables = { ...filters, [name]: value };
        baseSetFilters((prev) => ({ ...prev, ...variables }));
    }, [filters]);

    const cruises = useSelector((state) => state.tour.cruise.data);
    const {
        fetchingLoading: loading,
        isLoadingMore,
        hasMore,
    } = useSelector((state) => state.tour.cruise);

    useEffect(() => {
        handleFetchTourCruises({});
    }, [handleFetchTourCruises]);

    const handleFetchMore = useCallback(() => {
        handleFetchTourCruises({ currentPage: page, fetchMore: true });
    }, [handleFetchTourCruises, page]);

    return (
        <div id="tour-view-all" className="cruise-view-all">
            <Filters
                filters={filters}
                setFilters={setFilters}
                viewMode={viewMode}
                setViewMode={setViewMode}
                type="cruise"
                searchPlaceholder="Search for Cruise Tour"
                locationPlaceholder="Cruise Line"
                addNewItemText="Add new tour"
                addUrl="/app/tours/cruise/add"
                clearTourState={actions.clearCruiseState()}
            />
            { loading
                ? <Loading />
                : cruises.length === 0

                    ? (
                        <EmptyList
                            image={<EmptyListIcon />}
                            category={'Start creating cruise tour'.toUpperCase()}
                            message="Oops! Looks you haven't created yet any Cruise Tour"
                            url="/app/tours/cruise/add"
                        />
                    ) : (
                        <>
                            <CruiseList
                                cruises={cruises}
                                viewMode={viewMode}
                            />
                            {!isLoadingMore && hasMore && (
                                <Waypoint onEnter={() => handleFetchMore()} />
                            )}
                        </>
                    )}

        </div>
    );
};

export default ViewAll;
